import { assert, compare } from '@codegrade/utils';
/** The grading settings for an assignment. */
export class BaseAssignmentGradingSettings {
    /**
     * Assignment grading settings.
     *
     * Takes the data received from the server and makes them usable locally more
     * easily by unifying the types and making the settings comparable.
     *
     * @param scale The assignment grading scale.
     */
    constructor(
    /** The scale used in the assignment settings. */
    scale) {
        this.scale = scale;
    }
    /**
     * Extracts the assignment grading settings from the API data.
     *
     * @param apiData The object received from the API.
     * @returns The frontend assignment grading settings frontend model.
     */
    static fromServerData(apiData) {
        switch (apiData.scale) {
            case 'percentage':
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                return new PercentageAssignmentGradingSettings();
            case 'points':
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                return new PointsAssignmentGradingSettings(apiData.points);
            default:
                return assert.AssertionError.assertNever(apiData);
        }
    }
}
/** The point-scale grading settings for an assignment. */
export class PercentageAssignmentGradingSettings extends BaseAssignmentGradingSettings {
    /** Assignment grading settings.e types and making the settings comparable. */
    constructor() {
        super('percentage');
        Object.freeze(this);
    }
    /**
     * Returns whether the two grading settings are equal.
     *
     * @param other The other grading settings to compare to.
     * @returns Whether the grading scales are equal.
     */
    equal(other) {
        return other instanceof PercentageAssignmentGradingSettings;
    }
    /** @returns An assignment grading setting API object. */
    toJSON() {
        return { scale: this.scale };
    }
}
/** The point-scale grading settings for an assignment. */
export class PointsAssignmentGradingSettings extends BaseAssignmentGradingSettings {
    /**
     * Assignment grading settings.e types and making the settings comparable.
     *
     * @param points The points as a fraciton.
     */
    constructor(
    /** The points for the scale. */
    points) {
        super('points');
        this.points = points;
        Object.freeze(this);
    }
    /**
     * Returns whether the two grading settings are equal.
     *
     * @param other The other grading settings to compare to.
     * @returns Whether the grading scales are equal.
     */
    equal(other) {
        if (!(other instanceof PointsAssignmentGradingSettings)) {
            return false;
        }
        return compare.compare(this.points, other.points) === compare.Order.EQ;
    }
    /** @returns An assignment grading setting API object. */
    toJSON() {
        return { scale: this.scale, points: this.points };
    }
}
